import React, { useEffect, useRef, useState } from 'react';
import { container } from 'tsyringe';
import Top20 from '@base/features/ladder/components/top20/top20';
import RankingReport from '@base/features/ladder/components/rankingReport/rankingReport';
import RankCalculator from '@base/features/ladder/components/rankCalculator/rankCalculator';
import LadderNews from '@base/features/ladder/components/ladderNews/ladderNews';
import { IChallengeService, ILadderService } from '@base/features/ladder/model/interfaces';
import styles from '../styles/ladder.module.scss';
import { PlayerStatistics, IUserService } from '../../features/user/model/interfaces';
import Standings from '@base/features/ladder/components/standings/standings';
import Challenges from '@base/features/ladder/components/challenges/challenges';
import classNames from 'classnames';
import { useScroll } from '@utils/hooks';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';

export default function Ladder() {
  const ladderService: ILadderService = container.resolve('ladderService');
  const challengeService: IChallengeService = container.resolve('challengeService');
  const userService: IUserService = container.resolve('userService');
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const [myStatistics, setMyStatistics] = useState<PlayerStatistics>();
  const [showLadder, setShowLadder] = useState(true);
  const ladderRef = useRef<HTMLDivElement>(null);
  const newsRef = useScroll();

  useEffect(() => {
    (async () => {
      const myId = playersOnlineRepository.me?.userId;
      if (myId) {
        const statistics = await userService.getPlayerStats(myId);
        setMyStatistics(statistics);
      }
    })();
  }, [userService, playersOnlineRepository]);

  useEffect(() => {
    if (!ladderRef.current) return;
    ladderRef.current.scrollTop = showLadder
      ? 0
      : ladderRef.current.scrollHeight - ladderRef.current.clientHeight;
  }, [showLadder]);

  return (
    <main className={styles.ladder} ref={ladderRef}>
      <div className={classNames(styles.page, styles.grid)}>
        <section className={styles.top20}>
          <Top20 ladderService={ladderService} myRank={myStatistics?.Rank} />
        </section>
        <section className={styles.ladderNews} ref={newsRef}>
          <LadderNews ladderService={ladderService} />
        </section>
        <section className={styles.challenges}>
          <Challenges challengeService={challengeService} />
        </section>
        <section className={styles.rankingReport}>
          <RankingReport ladderService={ladderService} />
        </section>
        <section className={styles.calc}>
          <RankCalculator myRank={myStatistics?.Rank} />
        </section>
      </div>
      <div className={styles.page}>
        <Standings ladderService={ladderService} />
      </div>
      <button className={styles.switch} onClick={() => setShowLadder(!showLadder)}>
        <span>{showLadder ? 'standings' : 'ladder'}</span>
        <div style={{ transform: showLadder ? 'rotate(0)' : 'rotate(180deg)' }}>
          <svg
            width="12"
            height="9"
            viewBox="0 0 12 9"
            stroke="white"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M11 1.25L6 6.75L1 1.25" strokeWidth="2" />
          </svg>
        </div>
      </button>
    </main>
  );
}
